import {
  AuthenticationApiRemoteService,
  TPasswordResetMessageResponse,
  TPasswordResetRequestDTO,
} from '../../Services/api/auth/service-authentication'
import { IFormUsecase } from '../../Shared/Protocol/protocol-form-usecase'
import { Result } from '../../Shared/Protocol/protocol-result'

export class RequestPasswordResetUseCase
implements IFormUsecase<TPasswordResetRequestDTO, TPasswordResetMessageResponse> {
  constructor(private readonly authApi: AuthenticationApiRemoteService) {}

  public async handle(
    data: TPasswordResetRequestDTO
  ): Promise<Result<TPasswordResetMessageResponse>> {
    try {
      return await this.authApi.requestPasswordReset(data)
    } catch (error: any) {
      return Result.fail(error)
    }
  }
}
